export default {
  default: () => import("/opt/buildhome/repo/layouts/Default.vue").then(m => m.default || m),
  guest: () => import("/opt/buildhome/repo/layouts/Guest.vue").then(m => m.default || m),
  settings: () => import("/opt/buildhome/repo/layouts/Settings.vue").then(m => m.default || m)
}